
import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AddQuestion.css';
import { fetchExamTypes } from '../../../../api/examApi';
import { fetchCategories } from '../../../../api/categoryApi';
import { submitQuestion } from '../../../../api/questionApi';

const AddQuestion = ({ onClose }) => {
  const [examTypes, setExamTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [examType, setExamType] = useState('');
  const [category, setCategory] = useState('');
  const [questionDescription, setQuestionDescription] = useState('');
  const [options, setOptions] = useState(['', '', '', '']);
  const [isMultipleOptions, setIsMultipleOptions] = useState(false);
  const [correctOption, setCorrectOption] = useState('');
  const [explanation, setExplanation] = useState('');

  useEffect(() => {
    fetchExamTypesData();
  }, []);

  useEffect(() => {
    if (examType) {
      fetchCategoriesData(examType);
    } else {
      setCategories([]);
      setCategory('');
    }
  }, [examType]);

  const fetchExamTypesData = async () => {
    try {
      const data = await fetchExamTypes();
      setExamTypes(data); 
    } catch (error) {
      console.error('Error fetching exam types:', error);
      toast.error('Failed to fetch exam types. Please try again.');
    }
  };

  const fetchCategoriesData = async (examTypeId) => {
    try {
      const data = await fetchCategories();
      const filteredCategories = data.filter(cat => cat.examType.examTypeId === parseInt(examTypeId));
      setCategories(filteredCategories); 
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error('Failed to fetch categories. Please try again.');
    }
  };

  const handleExamTypeChange = (e) => {
    setExamType(e.target.value);
    setCategory('');
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const handleOptionChange = (index, value) => {
    const updatedOptions = [...options];
    updatedOptions[index] = value;
    setOptions(updatedOptions);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const questionData = {
        examType: { examTypeId: examType },
        category: { categoryId: category },
        description: questionDescription,
        correctAnswer: correctOption,
        explanation: explanation,
        isMultiSelection: isMultipleOptions ? 1 : 0,
        options: options.map((option, index) => ({
          optionSrNo: String.fromCharCode(65 + index),
          optionText: option,
        })),
      };

      await submitQuestion(questionData);
      toast.success('Question added successfully!');
      // console.log('qyedih successfully added')
      onClose(); 
    } catch (error) {
      console.error('Error submitting question:', error);
      toast.error('Failed to add question. Please try again.');
    }
  };

  return (
    <div className="add-question-container">
      <ToastContainer />
      <form className="add-question-form" onSubmit={handleSubmit}>
        <h3>Add New Question</h3>

        <div className="form-block">
          <div className="form-group">
            <label>Exam Type:</label>
            <select value={examType} onChange={handleExamTypeChange} required>
              <option value="">Select Exam Type</option>
              {examTypes.map((type) => (
                <option key={type.examTypeId} value={type.examTypeId}>
                  {type.examTypeDesc}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Category:</label>
            <select
              value={category}
              className="form-group-category-type"
              onChange={handleCategoryChange}
              required
              disabled={!examType}
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat.categoryId} value={cat.categoryId}>
                  {cat.categoryName}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>Question Description:</label>
          <textarea
            value={questionDescription}
            onChange={(e) => setQuestionDescription(e.target.value)}
            required
            placeholder="Enter the question description"
          ></textarea>
        </div>

        <div className="checkbox-group">
          <label>Multiple Options:</label>
          <input
            type="checkbox"
            checked={isMultipleOptions}
            onChange={() => setIsMultipleOptions(!isMultipleOptions)}
            className="checkbox-group-input"
          />
        </div>

        <div className="form-group">
          <label>Options:</label>
          {['A', 'B', 'C', 'D'].map((option, index) => (
            <div key={index} className="option-group">
              <input
                type="text"
                value={options[index]}
                onChange={(e) => handleOptionChange(index, e.target.value)}
                placeholder={`Option ${option}`}
                required
              />
            </div>
          ))}
        </div>

        <div className="form-group">
          <label>Correct Option:</label>
          <input
            type="text"
            value={correctOption}
            onChange={(e) => setCorrectOption(e.target.value)}
            placeholder={isMultipleOptions ? 'Correct Options: A, B' : 'Correct Option: A'}
            required
          />
        </div>

        <div className="form-group">
          <label>Explanation:</label>
          <textarea
            value={explanation}
            onChange={(e) => setExplanation(e.target.value)}
            placeholder="Enter the explanation"
            required
          ></textarea>
        </div>

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddQuestion;
